import { Button, Heading } from '@chakra-ui/react'

import { Container } from '../../../components/Container'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { Recap } from '../../../containers/sme/Recap'
import { MeetingRecordOverview } from '../../../containers/MeetingRecordOverview'
import { ContractRecap } from '../../../containers/sme/ContractRecap'
import { ExpiredContractCancellationForm } from '../../../containers/ExpiredContractCancellationForm'
import { InsuranceSummary } from '../../../containers/InsuranceSummary'
import { InsuranceDownloads } from '../../../containers/sme/InsuranceDownloads'
import { FormButtons } from '../../../containers/FormButtons'
import { Duplicate } from '../../../icons'

export const CompletedPage = () => {
  return (
    <Section>
      <Container>
        <StepsContent step={5}>
          <Heading
            sx={{
              fontSize: '5xl',
              fontWeight: 'bold',
              letterSpacing: 'tighter',
              textAlign: 'center',
            }}
            as="h1"
          >
            Sjednané pojištění č. 1683442791
          </Heading>

          <Steps icon="briefcase" />

          <InsuranceSummary />

          <MainContent>
            <InsuranceDownloads />

            <ExpiredContractCancellationForm onSubmit={() => { }} hideCompany hideDate />

            <Recap />

            <ContractRecap />

            <MeetingRecordOverview />
          </MainContent>
        </StepsContent>

        <FormButtons
          leftButtons={
            <>
              <Button variant="outline">
                <Duplicate color="secondary.500" />
                Klonovat
              </Button>
            </>
          }
        />
      </Container>
    </Section>
  )
}
